import React from 'react';
import { Mail, Phone, Trash2 } from 'lucide-react';
import { CONTACT_EMAIL, WHATSAPP_NUMBER } from '../config/api_config';
import { useLanguage } from '../i18n/LanguageContext';

export default function DeleteAccountPage() {
  const { t, isAr } = useLanguage();

  const message = isAr
    ? 'مرحباً حصيلة، أريد طلب حذف حسابي من تطبيق حصيلة.'
    : 'Hello Haseela, I would like to request deletion of my Haseela account.';

  return (
    <section className="section page-top">
      <div className="container narrow">
        <div className="section-head">
          <div className="icon-badge danger">
            <Trash2 size={28} />
          </div>
          <h1>{t.deleteAccount.title}</h1>
          <p>{t.deleteAccount.subtitle}</p>
        </div>

        <article className="content-panel">
          <h2>{t.deleteAccount.stepsTitle}</h2>
          <ol className="steps-ol">
            {t.deleteAccount.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </article>

        <div className="contact-row">
          <a
            className="btn btn-primary"
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone size={16} /> {t.deleteAccount.contact}
          </a>
          <a className="btn btn-soft" href={`mailto:${CONTACT_EMAIL}`}>
            <Mail size={16} /> {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
}
